// This import loads the firebase namespace along with all its type information.
import Thumbnail from './thumbnail-model'

export async function load_thumbnails(): Promise<Thumbnail[]> {
  throw 'Not implemented'
}

export async function delete_thumbnail(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_thumbnail(): Promise<Thumbnail> {
  throw 'Not implemented'
}
